import { H5 } from "@sellar-io/components";
import { twMerge } from "tailwind-merge";

import { FulfillmentTypeListResponseType } from "@sellar-io/api-v2/types";
import { getItemTypeTitle, CalculatedDeliveryOffer } from "@sellar-io/common";
import { CheckedIcon, UncheckedIcon } from "./CheckIcons";
import { formatPriceApiToInput } from "../../../../../../../hooks/usePriceFormat";

type ContainerTypeDeliveryChargeRule =
  FulfillmentTypeListResponseType[number]["ContainerTypeDeliveryChargeRules"][0];

const ContainerTypeDeliveryChargeRuleItem = ({
  remainder,
  qualifiesForFreeDelivery,
  rule,
}: {
  remainder: number;
  qualifiesForFreeDelivery: boolean;
  rule: ContainerTypeDeliveryChargeRule;
}) => {
  const containerTypeInBasket = remainder !== rule.value;
  const highlightClass = containerTypeInBasket ? "text-green-700" : "";
  const boldClass = containerTypeInBasket ? "font-bold" : "";
  const humanReadableContainerType = getItemTypeTitle(rule.containerType, 2);

  if (qualifiesForFreeDelivery) {
    return (
      <>
        <CheckedIcon className={"text-green-700"} />
        <p className={`col-span-11 font-bold text-green-700`}>
          Free delivery on {humanReadableContainerType}
        </p>
      </>
    );
  }

  return (
    <>
      <UncheckedIcon className={highlightClass} />
      <p className={twMerge(`col-span-11`, highlightClass)}>
        Spend{" "}
        <span className={boldClass}>£{formatPriceApiToInput(remainder)}</span>{" "}
        {remainder !== rule.value && " more "}
        on <span className={boldClass}>{humanReadableContainerType}</span>
      </p>
    </>
  );
};

export const ContainerTypeDeliveryChargeRulesSection = ({
  calculatedDeliveryOffers,
}: {
  calculatedDeliveryOffers: CalculatedDeliveryOffer[];
}) => {
  return (
    <div>
      <H5>FREE DELIVERY BY CONTAINER TYPE</H5>
      <div className={`grid grid-cols-12 items-center`}>
        {calculatedDeliveryOffers.map((deliveryOffer) => {
          return (
            <ContainerTypeDeliveryChargeRuleItem
              key={deliveryOffer.deliveryRule.id}
              rule={deliveryOffer.deliveryRule}
              qualifiesForFreeDelivery={deliveryOffer.qualifiesForFreeDelivery}
              remainder={deliveryOffer.remainder}
            />
          );
        })}
      </div>
    </div>
  );
};
